export default {
  calendar: {
    today: 'Astăzi',
    tomorrow: 'Mâine',
    asap: 'Cât mai curând',
  },
};
